<template>
  <div class="switch-channel">
    <div
      class="switch-btn"
      @click="handleOpen"
    >
      <img
        src="../images/icon_meau@2x.png"
        alt="switch"
      >
    </div>

    <transition name="popup-right">
      <div
        v-show="visible"
        class="live-channel-list-wrap"
        :style="{
          width: `${width}px`,
          height: `${height}px`
        }"
      >
        <div
          class="live-channel-mask"
          @click="handleClose"
        />
        <div
          class="live-channel-list"
          @click.prevent
        >
          <template v-for="(source, index) in channelList">
            <div
              v-if="typeof source === 'string'"
              :key="index"
              :class="{
                active: source === currentSource
              }"
              class="channel-btn"
              @click="chooseChannel(source)"
            >
              Channel {{ index + 1 }}
            </div>

            <!-- 对象类型 { source, title } -->
            <div
              v-else
              :key="index"
              :class="{
                active: source.source === currentSource
              }"
              class="channel-btn title tw-line-clamp-2"
              @click="chooseChannel(source.source)"
            >
              {{ source.title }}
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SwitchChannel',
  props: {
    channelList: {
      type: Array,
      default: () => []
    },
    currentSource: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      width: 0,
      height: 0
    }
  },
  mounted() {
    this.calcStyle()
  },
  methods: {
    handleOpen() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    chooseChannel(source) {
      this.$emit('change', source)
      this.visible = false
    },
    calcStyle() {
      this.width = this.$parent.$el.offsetWidth
      this.height = this.width * 0.75
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.switch-channel {
  position: absolute;
  z-index: 9;
  top: 0;
  right: 0;

  .switch-btn {
    position: absolute;
    top: 4px;
    right: 0;
    width: 39px;
    height: 36px;
    border-radius: 18px 0 0 18px;
    background: @primary;

    img {
      display: block;
      width: 18px;
      margin: 5px 0 0 13px;
    }
  }

  .live-channel-list-wrap {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 0;
    padding-bottom: 75%;
  }

  .live-channel-mask {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  .live-channel-list {
    position: absolute;
    top: 0;
    right: 0;
    overflow: auto;
    width: 50%;
    height: 100%;
    background: transparent linear-gradient(90deg, rgba(0, 0, 0, 0%) 0%, #000 41%);

    .channel-btn {
      width: 100px;
      height: 30px;
      box-sizing: border-box;
      padding: 2px 8px;
      border: 1px solid @primary;
      border-radius: 30px;
      margin: 10px auto;
      color: @primary;
      font-size: 12px;
      line-height: 24px;
      text-align: center;

      &.title {
        font-size: 10px;
        line-height: 12px;
        text-align: left;
      }

      &.active {
        background: @primary;
        color: #000;
      }

      &:active {
        opacity: 0.7;
      }
    }
  }
}

</style>
